var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StoreList',_vm._b({},'StoreList',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }